import { render, staticRenderFns } from "./IssueRow.vue?vue&type=template&id=a43c1eee&"
import script from "./IssueRow.vue?vue&type=script&lang=ts&"
export * from "./IssueRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports